import styles from "./css/BigButton.module.css"

export default function BigButton({ text, href, onClick, hoverColor }) {
    
    return (
        <div className={styles.buttonWrap}>
            <a className={styles.buttonText} href={href} onClick={onClick} style={{'--hover-color': hoverColor}}>{text}</a>
        </div>
    )
}